import { useEffect } from 'react';

const useBlockCtrlS = (): void => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent): void => {
      // Check if Ctrl (or Cmd on Mac) and 'S' are pressed together
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
        event.preventDefault(); // Prevent the default action
        console.log('Ctrl+S is blocked!');
      }
    };

    // Add event listener to the document
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export { useBlockCtrlS };
